<template>
<div class="page_set page">
    <div class="list">
        <div class="section">
            <div class="item" @click="goPage('set-account')">账户信息</div>
        </div>
        <div class="section">
            <div class="item" @click="goPage('set-staff')">员工认定</div>
            <div class="item" @click="goPage('set-card')">充值卡</div>
        </div>
        <div class="item" @click="show_zhizhao=true">平台经营者标识</div>
        <div class="item" @click="goSinglePage(1)">平台使用说明</div>
		<div class="item" @click="goSinglePage(9)">隐私保护指引</div>
        <div class="item" @click="goSinglePage(4)">帮助中心</div>
        <!-- <div class="item" @click="goSinglePage(21)">永久注销账号</div> -->
        <!-- <div class="item" @click="goPage('set-feedback')">意见反馈</div> -->
    </div>
    <div class="bottom">
        <div class="version">{{version}}</div>
        <div class="big_btn" @click="logout">退出登录</div>
        <div class="tel">客服电话：16601367749</div>
        <div class="version" @click="goZhuxiaoPage()">永久注销账号>></div>
    </div>
    <!-- 平台经营者 执照 -->
    <van-overlay :show="show_zhizhao" @click="show_zhizhao = false">
        <div class="zhizhao">
            <img :src="publicPath+'statics/images/shidaijiyi.png'" alt="" class="">
        </div>
    </van-overlay>
    <!-- 平台经营者 执照提示 -->
    <div class="zhizhao_tips" v-if="show_zhizhao" @click="show_zhizhao = false">点击任意位置关闭</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            version: '',
            show_zhizhao: false // 营业执照弹层
        };
    },
    created: function () {
        
    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            this.$bridge.callhandler('sdjy://public/getClientInfo', {}, (data) => {
                if (data.code == 200) {
                    this.version = data.result.version
                } 
        })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '设置',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    // console.log('1111111111:',data);
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
        // 退出
        logout() {
            var params = {
                token: this.token
            }
            this.$api.user.logout(params).then(res => {
                
            })
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {
                        forceLogin: 1
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    
                })
                this.$bridge.callhandler('sdjy://public/back', memberParams, (data) => {
                    
                })
            } else {
                this.$store.commit(LOGOUT);
				this.$router.push("/");
                var userinfo = localStorage.getItem("userInfo")
                if (userinfo != null && userinfo != undefined) {
                    this.$parent.msgLogOut();
                }
            }
		},
		// 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议
		goSinglePage(id){
			this.$router.push({
				path: '/single/page',
				query: {
					id: id
				}
			})
		},
        goZhuxiaoPage() {
            this.$router.push({
				path: '/set/zhuxiao'
			})
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
